import {checkToolWasUsed} from "../../Utils.ts";
import {MessageNode} from "../../../../../messageObject/MessageNode.ts";

export const handleToolCalls = (currentNode: MessageNode, trimmedMessages: any[], index: number, provider: string, addIfFound: any)=> {
    if (!currentNode.message.tool_calls) return null;

    const toolCalls: any[] = [];
    currentNode.message.tool_calls.forEach((x: any) => {
        let { id, name, args } = x;

        // Make sure the tool call was responded to. If not, don't include it
        const found = checkToolWasUsed(trimmedMessages, index, id);
        if (found) {
            addIfFound.add(id);

            if (typeof args === 'string') args = {};

            if (provider === "Anthropic") {
                toolCalls.push({type: "tool_use", id, name, input: args });
            } else {
                toolCalls.push({id, name, args});
            }
        }
    });

    return toolCalls;
};